import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const TOPBAR_ACTIONS_SLOT_ID = 'topbar-actions-slot';

/**
 * TopbarActions
 * -------------
 * Renders its children into the app shell's top bar, on the right-hand side
 * (mockup 1c: "Lesson 3 of 42 · Share lesson" live in the header, not in the
 * outline rail). Pages mount this anywhere in their tree; the shell owns the
 * placement.
 *
 * The slot node is created by Layout, which mounts before any page, but the
 * portal target still has to be resolved in an effect rather than at render:
 * on the very first paint of a route the ref-populated node may not be in the
 * DOM yet. State-then-portal keeps that a one-frame no-op instead of a crash.
 *
 * Renders nothing when the shell is hidden (splash, login, legal pages) —
 * there is no top bar to portal into.
 */
export default function TopbarActions({ children }) {
  const [slot, setSlot] = useState(null);

  useEffect(() => {
    setSlot(document.getElementById(TOPBAR_ACTIONS_SLOT_ID));
  }, []);

  if (!slot) return null;
  return createPortal(children, slot);
}
